// extracted by mini-css-extract-plugin
module.exports = {"title":"SignInForm_title__3aKyu","submit":"SignInForm_submit__2DbyC","forgot":"SignInForm_forgot__3_iUU"};